import React, { Fragment } from "react";
import {
  PrivTermsImg1Src,
  PrivTermsImg2Src,
} from "../../../../resources/Assets";

export const Private_20231220 = () => {
  return (
    <Fragment>
      <pre style={{ whiteSpace: "pre-wrap" }}>
        {`제1조(개인정보 처리목적)
㈜미라벨 소프트는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.

제2조(개인정보 수집항목 및 이용목적)
회사는 회원관리, 서비스 제공∙개선, 신규 서비스 개발, 헬스케어 연구발전 등을 위해 개인정보를 수집 및 이용합니다. 또한 회사는 회원 가입시 또는 서비스 이용과정에서 홈페이지 또는 앱 서비스나 프로그램 등을 통해 아래와 같이 서비스 제공을 위해 필요한 최소한의 개인정보를 수집하고 있습니다.

  (1) 회원가입과 관리 및 본인확인
  ① 수집 목적: 회원가입 및 관리와 본인확인
  ② 필수 수집 항목: 이름, 생년월일, 성별, 휴대폰번호, 로그인 계정 아이디, 비밀번호, 본인식별번호(DI, CI), 
    -네이버계정으로 가입시: 네이버 연동 아이디, 네이버 토큰
    -카카오계정 가입시: 카카오 연동 아이디, 카카오 토큰 
    -애플계정 가입시: 애플 연동 아이디, 애플 토큰
  ③ 선택 수집 항목: 이메일, 연동병원
  ④ 보유 및 이용기간: 회원 탈퇴 까지

  (2) 자가건강관리 데이터
  ① 수집 목적: 회원의 건강관리 서비스 제공과 개선·고도화
  ② 필수 수집 항목: 이름, 생년월일, 성별, 휴대폰번호, 로그인 계정 아이디
  ③ 선택 수집 항목: 
    -건강관리: 혈압, 혈당, 목표혈압, 목표혈당, 당화혈색소, 심박수, 식사기록, 메모
    -기초문진정보: 혈액형, 키, 몸무게, BMI, 알레르기, 병력, 가족력, 예방접종 현황
    -생활습관: 흡연유무와 흡연량, 음주유무와 횟수, 주량
  ④ 보유 및 이용기간: 회원탈퇴 까지

  (3) 진료 및 검사 데이터
  ① 수집 목적: 회원의 진료, 검사 서비스 제공과 개선·고도화
  ② 필수 수집 항목: 로그인 계정 아이디, 이름, 생년월일, 성별, 휴대폰번호
  ③ 선택 수집 항목: 
    -의료자료: 처방전, 진료일, 진료자료, 검사자료, 교육자료, 제증명서류 등 회원이 업로
    드한 자료 및 병원이 회원에게 전송한 자료
  ④ 보유 및 이용기간: 회원탈퇴 까지

  (4) 비대면진료 예약, 중개 및 처방
  ① 수집 목적: 비대면진료 예약 및 진료, 치료를 위한 처방전 서비스 제공과 고도화
  ② 필수 수집 항목: 로그인 계정 아이디, 이름, 생년월일, 성별, 휴대폰번호
  ③ 선택 수집 항목: 
  비대면진료 예약신청 병/의원 등의 의료기관, 예약일시, 증상, 본인확인을 
  위한 신분증, 결제정보, 예약일시, 진료일시
  ④ 보유 및 이용기간: 회원 탈퇴까지

  (5) 연구
  ① 수집 목적: 통계 및 기타 분석을 통한 과학적 연구 발전
  ② 필수 수집 항목: 로그인 계정 아이디, 생년월일, 성별,
  ③ 선택 수집 항목: 혈액형, 키, 몸무게, BMI, 알레르기, 병력, 가족력, 예방접종 현황, 흡연유무와 흡연량, 음주유무와 횟수, 주량, 진료자료 및 검사 데이터, 서비스 이용기록(쿠키)
  ④ 보유 및 이용기간: 회원 탈퇴까지

  (6) 서비스 품질관리 및 통계
  ① 수집 목적: 서비스 품질 개선 및 맞춤형 서비스 개선
  ② 수집 항목: 로그인 계정의 접속로그, 서비스 이용기록(쿠키), 단말기 모델명, 사용OS, 안드로이드 기기인 경우 sdk버전
  ③ 수집방법: 서비스 이용 시 자동 수집
  ④ 보유 및 이용기간: 회원 탈퇴까지

  (7) 서비스 품질 향상 및 마케팅 광고에 활용
  ① 수집 목적: 회원의 이용행태분석을 통해 서비스 품질 개선 및 의료기관 서비스 개선
  ② 필수 수집 항목: 로그인 계정의 접속로그, 서비스 이용기록(쿠키)
  ③ 선택 수집 항목: 병원/의원 등의 의료기관, 생년월일, 혈액형, 키, 몸무게, BMI, 알레르기, 병력, 가족력, 예방접종 현황, 흡연유무와 흡연량, 음주유무와 횟수, 주량
  ④ 보유 및 이용기간: 회원 탈퇴까지



제3조(개인정보의 처리 및 보유기간)
1. 회사는 법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
2. 각각의 개인정보 처리 및 보유기간은 다름과 같습니다. 
  (1) 관련법령 및 회사 방침에 의한 정보보유 사유
  ① 계약 또는 청약철회 등에 관한 기록: 5년(전자상거래등에서의 소비자보호에 관한 법률)
  ② 대금결제 및 재화 등의 공급에 관한 기록: 5년(전자상거래등에서의 소비자보호에 관한 법률)
  ③ 소비자의 불만 또는 분쟁처리에 관한 기록: 3년(전자상거래등에서의 소비자 보호에 관한 법률)
  ④ 본인확인에 관한 기록 보유: 회원탈퇴시까지(정보통신망 이용촉진 및 정보보호 등에 관한 법률)
  ⑤ 방문에 관한 기록 보유: 3년(개인정보는 원칙적으로 개인정보의 처리목적이 달성되면 지체없이 파기하며 정보주체의 동의 및 보안업무규정 제46조 제1항이 운영근거)
3. 수집된 개인정보의 보유/이용기간은 서비스 이용계약체결(회원가입)시부터 서비스 이용계약해지(회원탈퇴, 직권탈퇴 포함)까지를 의미합니다.
4. 회사는 위치정보의 보호 및 이용 등에 관한 법률 제16조 제2항에 근거하여 이용자의 위치정보 수집ㆍ이용ㆍ제공사실 확인자료를 6개월이상 보관합니다.


제4조(개인정보의 파기절차 및 방법)
회사는 개인정보수집 및 이용목적을 달성한 후에는 지체없이 해당 정보를 파기합니다. 
회사의 개인정보 파기 절차 및 방법은 다음과 같다.
1. 파기절차
  가. 회사는 개인정보의 파기에 관한 사항을 기록하고 관리하며, 파기는 개인정보 보호 책임자의 책임하에 수행되며, 개인정보 보호 책임자는 파기결과를 확인합니다.
  나. 회사는 다른 법령에 따라 보존해야 하는 경우에는 예외적으로 이용자의 개인정보를 파기하지 않을 수 있습니다.
2. 파기방법
  가. 종이나 그 밖의 기록매체에 저장된 개인정보는 파쇄하거나 소각합니다.
  나. 전자적 파일의 형태로 저장된 개인정보는 복원이 불가능한 방법(내지 기록을 재생할 수 없는 기술적 방법)으로 영구 삭제합니다. 
3. 미파기 정보의 보존 방법 회사는 법령에 따라 개인정보를 파기하지 않고 보존하는 경우 해당 개인정보 또 는 개인정보파일을 다른 개인정보와 분리하여 저장.관리합니다. 회사는 별도 DB 로 옮긴 개인정보를 법률에 의한 경우가 아니고서는 보유하는 목적 이외의 목적으로 이용하지 않습니다.
4. 회사는 개인위치정보의 파기 절차 및 방법과 관련하여 개인위치정보를 일회성 또는 임시로 이용 후 별도로 저장하거나 관리하지 않으며 재생이 불가능한 방법으로 안전하게 파기하고 있습니다. 


제5조(개인정보의 제3자 제공)
회사는 정보주체의 개인정보를 “제1조(개인정보 처리목적)”에서 명시한 범위 내에서만 처리합니다.`}
      </pre>
      <img src={PrivTermsImg1Src} style={{ width: "100%" }} />
      <pre style={{ whiteSpace: "pre-wrap" }}>
        {`2. 회사는 회원이 진료를 목적으로 개인정보제공을 동의한 경우에만 사용자가 지정한 의료기관에 제공합니다. 
3. 회원은 개인정보 동의를 거부할 수 있습니다. 단, 거부시에 관련 서비스에 대한 제공이 불가합니다.
4. 회사는 개인위치정보의 제3자 제공에 관련하여 개인위치정보를 제3자에게 제공하지 않습니다.
5. 회사는 서비스 제공을 위해 병/의원, 약국 위치 파악을 위한 개인위치정보를 제3자에게 제공하지 않으며, 이용자가 동의 및 지정한 제3자에게 개인위치정보를 제공하는 경우 매회 개인위치정보주체인 회원에게 제공받는자, 제공일시 및 제공목적을 즉시 통보합니다.
6. 회사는 법률상 적법한 권한이 있는 기관에 의한 질병과 진료예방치료 및 실제증거, 과학의 발전을 위한 연구, 정밀·맞춤형 의료서비스 개선과 개발, 보건의료기술(의과학, 의료공학, 의료정보학에 관련되거나 의약품, 의료기기, 의료정보시스템 관련) 연구개발, 치료·의약품·의료기기 효과 보고서에 사용될 수 있습니다.


제6조(연구데이터의 처리)
회사는 보건의료데이터 활용 가이드라인(관련 법령 개인정보보호법 제2조, 제3절 가명정보 처리에 관한 특례에 따라 연구데이터를 안전하게 처리합니다.
1. 개인정보처리자는 과학적 연구, 통계작성 등을 위하여 정보주체의 동의 없이 가명정보를 이용, 제공, 결합 등을 처리할 수 있습니다(「개인정보 보호법」제28조의2 제1항, 제28조의3 제1항).
2. 연구목적을 위해 처리된 데이터는 개인정보의 신원확인이 불가능하도록 암호화하여 보관합니다. 
3. 연구목적을 위해 처리된 데이터에는 이름, 전화번호 또는 이메일 주소등 신원확인이 가능한 데이터를 취급하지 않습니다. 신원확인 불가능화, 가명화된 데이터 세트는 안전하게 보관하며 이용자의 신원을 개별적으로 확인하는데 사용하지 않습니다.
4. 연구자는 연구윤리 확보를 위한 지침(교육부훈령 제449호, 2023. 7.17)에 따라 연구대상자의 개인정보 및 사생활 보호를 준수하여 특정 개인을 알아볼 수 없는 형태로 처리합니다.


제7조(개인정보주체의 권리와 그 행사방법)
1. 이용자는 언제든지 회사의 서비스에 등록되어있는 자신의 개인정보, 회사가 이 용자의 개인정보를 이용하거나 제3자에게 제공한 현황, 회사에게 개인정보 수집.이용.제공 등의 동의를 한 현황에 대하여 열람이나 제공을 요구할 수 있고, 오류 가 있는 경우에는 그 정정을 요구할 수 있으며, 삭제 내지 가입해지(회원탈퇴)를 요구할 수 있습니다.
2. 이용자 혹은 만14세 미만 아동의 개인정보 조회 및 그 수정을 위해서는 ‘개인정보변경’(또는 ‘이용자 정보 수정’ 등)을, 가입해지(동의철회)를 위해서는 ‘이용자 탈퇴’(또는 ‘회원 탈퇴’ 등)를 클릭하여 직접 열람한 후 정정 또는 탈퇴가 가능합니다.
3. 전2항의 경우 회사는 지체없이 그 개인정보를 조사하여 이용자의 요구에 따라 정정, 삭제 등 필요한 조치를 한 후 그 결과를 그 이용자에게 알립니다. 회사는 필요한 조치를 취할 때까지는 해당 개인정보를 이용하거나 제공하지 않습니다.
4. 이용자는 언제든지 회사에 자신의 개인정보 처리의 정지를 요구할 수 있으며, 이 경우 회사는 지체없이 그 요구에 따라 개인정보 처리의 전부 또는 일부를 정지하며, 처리가 정지된 개인정보에 대하여 지체없이 그 개인정보의 파기 등 필요한 조치를 취합니다.
5. 개인정보와 관련하여 의견이 있으신 분은 개인정보 보호 책임자 및 담당자에게 서면, 전화 또는 E-mail로 연락하시면, 접수 즉시 처리하고 그 결과를 안내해 드리겠습니다.
6. 이용자는 로그온(log-on)한 상태에서는 주위의 다른 사람에게 개인정보가 유출되지 않도록 특별히 주의를 하셔야 합니다.
7. 회사는 보호의무자의 권리·의무 등에 관하여 아래에 해당하는 이용자의 보호의무자가 8세 이하의 아동 등의 생명 또는 신체보호를 위하여 개인위치정보의 이용 또는 제공에 동의하는 경우 본인의 동의가 있는 것으로 봅니다. 보호의무자는 8세 이하 아동 등의 개인위치정보 이용 또는 제공에 동의하는 경우 개인위치정보주체 권리의 전부를 행사할 수 있습니다. 



제8조(개인정보의 위탁)
회사는 서비스를 원활하게 이행하기 위해 전문업체에 위탁하여 운영하고 있습니다. 
`}
      </pre>
      <img src={PrivTermsImg2Src} style={{ width: "100%" }} />
      <pre style={{ whiteSpace: "pre-wrap" }}>
        {`
제9조(개인정보의 기술적, 관리적 보호 대책)
회사는 이용자들의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성의 확보를 위해 다음과 같은 기술적. 관리적 보호 대책을 강구하고 있습니다.
1. 기술적 조치
가. 비밀번호 암호화 회원 아이디(ID)의 비밀번호는 암호화되어 저장 및 관리되고 있어 이용자만 알고 있으며 회사가 이를 직접 조회하거나 수정할 수 없습니다. 또한 개인정보의 확인 및 변경도 계정정보를 통해 일치하는 경우에만 가능합니다.
2. 관리적 보호 대책
가. 해킹 등에 대한 대비책 회사는 해킹이나 컴퓨터 바이러스 등에 의해 회원의 개인정보가 유출되거나 훼손되는 것을 막기 위해 최선을 다하고 있습니다. 또한 개인정보의 훼손에 대비해서 자료를 수시로 백업하고 있고, 최신 백신프로그램을 이용하여 이용자들의 개인정보나 자료가 유출되거나 손상되지 않도록 방지하고 있으며, 암호화 통신 등을 통하여 네트워크상에서 개인정보를 안전하게 전송할 수 있도록 하고 있습니다. 그리고 침입차단시스템을 이용하여 외부로부터의 무단 접근을 통제하고 있으며, 기타 시스템적으로 보안성을 확보하기 위한 가능한 모든 기술적 장치를 갖추려 최선을 다하고 있습니다.


제10조(개인정보 자동 수집장치의 설치·운영 및 거부에 관한 사항)
1. 쿠키(cookie)의 사용
가. 회사는 개인화되고 맞춤화된 서비스를 제공하기 위해 ‘쿠키(cookie)’를 사용합니다.
나. 쿠키란 웹사이드를 운영하는데 이용되는 서버가 이용자의 브라우저에게 보내는 작은 텍스트 파일로서 이용자의 하드디스크에 저장됩니다. 
2. 쿠키(cookie)의 사용 목적
가. 회사는 이용자의 접속방법에 대한 유형을 파악하여 서비스 개선에 활용합니다.
나. 회사는 쿠키를 통해 서비스의 접속, 방문시간 및 빈도 등을 분석하여 이용자에게 보다 빠른 서비스 제공에 활용합니다.
3. 쿠키(cookie)의 설정 거부
가. 이용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 이용자는 웹브라우저에서 옵션을 설정하여 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거티거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.
나. 쿠키 설치 허용 여부를 지정하는 방법은 다음과 같습니다. (인터넷 익스플로러의 경우): 웹 브러우저 상단의 도구> 인터넷 옵션> 개인정보 탭>개인정보처리 수준(구글 크롬의 경우): 웹 브라우저 상단의 설정> 개인정보 및 보안> 쿠키 및 기타 사이트(마이크로소프트 엣지의 경우): 웹 브러우저 상단의 설정 > 쿠키 및 사이트 권한단, 쿠키 저장을 거부하셨을 경우 로그인 및 필요한 서비스 사용에 어려움이 있을 수 있습니다.



제11조(개인정보보호 책임자 및 담당자의 연락처)
1. 회사는 이용자의 개인정보를 보호하고 개인정보를 안전하게 보호하기 위해 아래와 같은 담당자를 지정하고 있습니다. 또한 이용자의 신고사항에 신속하게 답변을 드리기 위해 노력하고 있습니다.
가. 개인정보보호 책임자: 류대선
나. 소속/ 직위: 미라벨소프트/ 이사
다. 전화번호: 1877-4872
라. 이메일: dsryu@mirabellsoft.com
2. 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다. 
가. 개인정보침해 신고센터 (http://privacy.kisa.or.kr / 국번 없이 118)
나. 대검찰청 사이버수사과 (www.spo.go.kr / 국번 없이 1301)
다. 경찰청 사이버수사국(https://ecrm.cyber.go.kr)
라. 개인정보 분쟁조정위원회(www.kopico.go.kr / 1833-6972)
3. 회사의 위치정보 관리책임자는 전항의 개인정보보호 책임자가 겸직하고 있습니다. 

제12조(개정 전 고지 의무)
1. 현 개인정보 처리방침에 대해 추가, 삭제 및 수정이 있을시에는 개정 최초 7일 전부터 서비스 ‘공지사항’을 통해 고지할 것입니다. 
2. 전항에도 불구하고 이용자 권리에 대한 중대한 내용이 변경되는 경우 최소 30일 전에 고지 합니다. 변경된 개인정보 처리방침은 고지한 적용일로부터 효력이 발생합니다. 

공고일자: 2023년 11월 17일
시행일자: 2023년 12월 20일
        `}
      </pre>
    </Fragment>
  );
};
